import { SurveyResponseState } from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseStates";
import { ToxnotComponentProperties } from "../BaseApplicationComponents/ToxnotComponent";
import * as SurveyResponseController from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseController";
import { ToxnotSignInRequiredComponent } from "../BaseApplicationComponents/ToxnotSignInRequiredComponent";
import { TeamRole } from '../../../store/Models/UserContext';
import { ApplicationState } from "../../../store";
import { connect } from 'react-redux';
import { ResponseBomType } from "../../../store/Models/Surveys/SurveyDataModel";
import BatchButtons from "../BatchButtons/BatchButtons";

export type BatchProps =
    ToxnotComponentProperties &
    typeof SurveyResponseController.actionCreators &
    SurveyResponseState;

class BulkInputs extends ToxnotSignInRequiredComponent<BatchProps>{
    
    public constructor(props: BatchProps) {
        super(props);
    }

    protected getDisallowedRoles(): TeamRole[] {
        return [TeamRole.Marketing, TeamRole.Viewer];
    }

    protected renderConcreteComponent(): JSX.Element | null {
        const needsMaterialBomResponse = (this.props.coreData?.response?.bomType != ResponseBomType.None) &&
            (!this.props.coreData?.response?.isRevisionResponse || this.props.coreData?.response?.inventoryDataList.some(inv => inv.revisionRequest != null))
            && this.props.coreData?.request?.dataRequested?.materialDisclosureAsked == true;

        return <BatchButtons localizer={this.props.appServices}
            responseId={this.props.responseId}
            materialIdsDataToLoadList={this.props.coreData?.materialIdsDataToLoadList}
            requestedData={this.props.coreData?.request?.dataRequested}
            bomQuestionnaireId={this.props.coreData?.request?.bomQuestionnaireId ?? ""}
            needsMaterialBomResponse={needsMaterialBomResponse }
        />
    }
}
export default connect(
    (state: ApplicationState) => ({ ...state.surveyResponseState, appServices: state.appServices }),
    SurveyResponseController.actionCreators
)(BulkInputs as any);
